import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz/client';

import { formatPrice } from '@spotahome/soyuz-currency';

import styles from './DetailRow.module.scss';

import InfoTooltip from './InfoTooltip';

const DetailRow = ({
  label,
  tooltipText = null,
  value = null,
  valueWithoutOffer = null,
  compareValueForStrike = null,
  currencyCode = null,
  labelSubtitle = null,
  valueSubtitle = null,
  included = false,
  includedCopy = null
}) => {
  const baseForStrike =
    typeof value === 'number' ? value : compareValueForStrike;
  const hasStrike =
    typeof valueWithoutOffer === 'number' &&
    valueWithoutOffer != null &&
    typeof baseForStrike === 'number' &&
    baseForStrike !== valueWithoutOffer;

  const displayValue =
    typeof value === 'number' ? formatPrice(value, currencyCode) : value;

  return (
    <div className={styles['payment-detail-row']}>
      <div className={styles['payment-detail-row__label-block']}>
        <div className={styles['payment-detail-row__label']}>
          <span>{label}</span>
          {tooltipText ? (
            <InfoTooltip
              title={label}
              className={styles['payment-detail-row__label-tooltip']}
              tooltipText={tooltipText}
            />
          ) : null}
        </div>
        {labelSubtitle ? (
          <div className={styles['payment-detail-row__label-subtitle']}>
            {labelSubtitle}
          </div>
        ) : null}
      </div>
      <div className={styles['payment-detail-row__value-column']}>
        {included ? (
          <>
            <span className={styles['payment-detail-row__included-value']}>
              {includedCopy ?? trans('listing.bills.is-included')}
            </span>
            {valueSubtitle ? (
              <div className={styles['payment-detail-row__value-subtitle']}>
                {valueSubtitle}
              </div>
            ) : null}
          </>
        ) : (
          <>
            <div className={styles['payment-detail-row__prices']}>
              {hasStrike ? (
                <>
                  <span className={styles['payment-detail-row__price']}>
                    {displayValue}
                  </span>
                  <span
                    className={styles['payment-detail-row__price--muted']}
                    aria-hidden
                  >
                    {formatPrice(valueWithoutOffer, currencyCode)}
                  </span>
                </>
              ) : (
                <span className={styles['payment-detail-row__price']}>
                  {displayValue}
                </span>
              )}
            </div>
            {valueSubtitle ? (
              <div className={styles['payment-detail-row__value-subtitle']}>
                {valueSubtitle}
              </div>
            ) : null}
          </>
        )}
      </div>
    </div>
  );
};

DetailRow.propTypes = {
  label: PropTypes.string.isRequired,
  tooltipText: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.func
  ]),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  valueWithoutOffer: PropTypes.number,
  compareValueForStrike: PropTypes.number,
  currencyCode: PropTypes.string,
  labelSubtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  valueSubtitle: PropTypes.string,
  included: PropTypes.bool,
  includedCopy: PropTypes.string
};

export default DetailRow;
